export default __webpack_public_path__ + "static/Manufacturer_logs_on_road-d729528b95d935413d0efdbc88cfde01.png";